module.exports = __webpack_public_path__ + "static/media/image-gallery-7.5550cb3a.jpg";